import callAPI from '../ApiConfig'

/**
 * Get settings for a specific mizan
 */
const getMizanSettings = async (props) => {
    return await callAPI({
        route: "mizan_settings/" + props?.mizanListId,
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

/**
 * Create or update settings for a mizan
 */
const saveMizanSettings = async (props) => {
    return await callAPI({
        route: "mizan_settings/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

/**
 * Update settings for a mizan
 */
const updateMizanSettings = async (props) => {
    return await callAPI({
        route: "mizan_settings/" + props?.mizanListId,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
        }
    })
}

const mizanSettingsAPI = {
    getMizanSettings,
    saveMizanSettings,
    updateMizanSettings,
}

export default mizanSettingsAPI
